import { getCommonLabel, type CommonStateType } from "../../common-deprecated/utils/commonLabels";
import { formatPriceIntl } from "../../common-deprecated/priceUtils";

import { limitFractionDigits } from "./priceUtils";

export const dualCurrencyDisclaimerSelector = (state: CommonStateType): string => {
    const { commonSettings } = state;

    const { currencyMultiplier } = commonSettings;
    const dualCurrencySymbol =
        commonSettings.culture.numberFormat?.secondaryCurrency?.symbol || commonSettings.intl.secondaryCurrencyCode;
    const { currencyCode } = commonSettings.intl;

    if (commonSettings.reverseCurrencyMultiplier) {
        const secondary = `${(1 / currencyMultiplier).toString().replace(".", ",")} ${currencyCode as string}`;
        return getCommonLabel(state, "dualCurrencyDisclaimer", {
            value: `${
                formatPriceIntl(
                    commonSettings,
                    1,
                    {
                        currencyDisplay: "code",
                    },
                    true,
                    undefined,
                    undefined,
                    commonSettings.reverseCurrencyMultiplier,
                ).primaryPrice
            }  = ${limitFractionDigits(secondary, commonSettings.intl.currencyDecimals)}`,
        });
    }
    return getCommonLabel(state, "dualCurrencyDisclaimer", {
        value: `${
            formatPriceIntl(commonSettings, 1, {
                currencyDisplay: "code",
            }).primaryPrice
        }  = ${currencyMultiplier} ${dualCurrencySymbol as string}`,
    });
};
